import { UploadFile } from './UploadFile'
import { withUploadFile } from './withUploadFile'

const ConnectedUploadFile = withUploadFile(UploadFile)

export { ConnectedUploadFile as UploadFile }
